module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/contracts/act-dialog/act.dialog.contracts.component.css
// module id = ./src/app/components/dashboard/contracts/act-dialog/act.dialog.contracts.component.css
// module chunks = main